import { IContainerProps } from 'props';
import styled from 'styled-components';

export const Container = styled.div<IContainerProps>`
  width: 85%;
  max-width: 100rem;
  position: relative;
  border-radius: 15px;
  padding: 1.5rem;
  background: ${({ theme, color }) => theme.colors[color]};

  @media (max-width: 900px) {
    width: -webkit-fill-available;
    margin: 0 1.5rem;
  }

  @media (max-width: 320px) {
    margin: 0 0.5rem;
    padding: 0.5rem;
  }
`;
export const Content = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  width: 100%;

  button {
    padding: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 25rem;
    gap: 1rem;

    .section {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
          font-size: 1.5rem;
          font-weight: bold;
          color: ${({ theme }) => theme.colors.primary};
          background: none;
          border: none;
          cursor: default;
        }
      }
      .containerNumberInscription {
        display: flex;
        min-width: 15rem;
        gap: 1rem;
        align-items: flex-end;
      }
    }

    .TextField {
      width: 100%;
    }
  }

  .containerDropzone {
    width: 100%;
    display: flex;
    min-width: 50rem;
    justify-content: space-between;
    gap: 1rem;
    margin: 1.5rem 0;

    h1 {
      font-size: 1.5rem;
      color: ${({ theme }) => theme.colors.text};
    }

    .contentDropzone {
      width: 40%;
      .dropzone {
        margin-top: 0.5rem;
      }
    }
  }

  .containerProfileVerified {
    display: flex;
    padding: 1rem;

    h1 {
      display: flex;
      gap: 0.5rem;
      font-size: 1.3rem;
      color: ${({ theme }) => theme.colors.tertiary_500};
      align-items: center;
      font-weight: 400;
    }
  }
  .warning {
    h1 {
      display: flex;
      gap: 0.5rem;
      font-size: 1.3rem;
      align-items: center;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.error_500};
    }
  }

  @media (max-width: 750px) {
    .containerDropzone {
      flex-direction: column;
      align-items: center;
      margin-top: 2rem;

      .contentDropzone {
        width: 100%;
      }
    }
  }

  @media (max-width: 768px) {
    .contentDropDown {
      width: 60%;
    }
  }
`;
export const ContentSummary = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .headerSummary {
    display: flex;
    justify-content: space-between;
    width: 100%;

    button {
      padding: 0;
      font-size: 1.7rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.secondary};
      background: transparent;
      border: none;
      cursor: pointer;
    }
  }

  .contentType {
    padding: 0.5rem;

    .text {
      display: flex;
      gap: 0.5rem;
      font-size: 1.3rem;
      color: ${({ theme }) => theme.colors.tertiary_500};
      align-items: center;
      background: none;
      border: none;
      cursor: pointer;
    }
  }
`;
